import React, { Component } from "react";
//import open_url from '../../images/open_url.svg';Commented because not in use
import { userService } from "../../_services";
import $ from 'jquery';
class Groupno_summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            GroupNumberList: this.props.groupnumber
        };
    }
    componentDidMount() {
        try {
            if (this.props.groupnumber.length > 0) {

            }
            else {
                let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                this.Get_User_Summary_Details(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            }
        }
        catch (error) {
        }
    }
    Get_User_Summary_Details(UserId, UserName) {
        try {
            userService.GetUserSummaryDetail(UserId, UserName)
                .then(
                    apidata => {
                        if (apidata.length > 0) {
                            this.setState({ GroupNumberList: apidata[0].groupNumber })
                        }
                    }
                );
        }
        catch (error) {
        }
    }
    handleSearchFilter = (e) => {
        try {
            let val = e.target.value.toLowerCase();
            let filtered = $('.groupnumbers_summary').find('.gn');
            $(filtered).filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(val) > -1)
            });
        }
        catch (error) {
            //let s = error;Commented because not in use
        }
    }
    //    try {
    //    let val = e.target.value.toLowerCase();
    //    let filtered = $('.groupnumbers_summary').find('.gn');
    //    $(filtered).filter(function () {
    //        $(this).toggle($(this).text().toLowerCase().indexOf(val) > -1)
    //    });
    //}
    //catch (error) { }
    render() {
        let showemail = userService.getemail();
        return (
            <div>
                <div className="Transactions_Summary group_no_box">
                    {
                        this.state.GroupNumberList != null && this.state.GroupNumberList.length > 0 ?
                            <div className="group-nos">
                                <div className="header">
                                    Group Numbers
                                    <div><a href={"mailto:" + showemail}>Request More</a></div>
                                </div>
                                <div className="content">
                                    {
                                        <p>Total Group Numbers: <span>{this.state.GroupNumberList.length}</span></p>
                                    }
                                </div>
                                <div className="searchbox">
                                    <input type="text" placeholder="Group Number" onKeyUp={this.handleSearchFilter} />
                                </div>
                                <div className="groupnumbers_summary">
                                    {
                                        this.state.GroupNumberList.map((uitem, _index) => {
                                            return <div className="gn" key={_index}>{uitem.value}</div>
                                        })
                                    }

                                </div>
                            </div> : <div className="group-nos">
                                <div className="header">
                                    Group Numbers
                                    <div><a href={"mailto:" + showemail}>Request More</a></div>
                                </div></div>
                    }
                    <div className="compunsation-plan">
                        <div className="header">
                            Compensation Plan
                        </div>
                        <div className="tabular_box">
                            <div className="table_header groupNoHeader">
                                <div>Transactions</div>
                                <div>Commission($)</div>
                            </div>
                            <div className="table_body">
                                <div className="table_row">
                                    <div className='groupNoRow'>
                                        <div>0-499</div>
                                        <div>$1.00</div>
                                    </div>
                                </div>
                                <div className="table_row">
                                    <div className='groupNoRow'>
                                        <div>500-999</div>
                                        <div>$1.50</div>
                                    </div>
                                </div>
                                <div className="table_row">
                                    <div className='groupNoRow'>
                                        <div>1000</div>
                                        <div>$1.75</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>Eligibility for higher compensation tiers is granted on a case by case basis. Please <a href="mailto:support@nulifespanrx.com">get in touch</a> with an administrator to learn more.</p>
                    </div>
                </div>
            </div>
        )
    }
}
export default Groupno_summary;
